import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Page Not Found</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        If you think this is not should not be an error, <br /> raise a ticket to
        support@asparksys.com
      </div>
    </>
  )
}

export {Error404}
